import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { formatMoney } from "@/lib/format";
import { AccDot } from "@/lib/finance";

export default function DemoArchiveDialog({ onClose, onDone }) {
  const [items, setItems] = useState(null);
  const [sel, setSel] = useState(new Set());
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/finans/hesaplar/demo").then(({ data }) => { setItems(data.items); setSel(new Set(data.items.map((a) => a.id))); }); }, []);
  const toggle = (id) => setSel((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.post("/finans/hesaplar/demo-arsivle", { reason: reason.trim(), account_ids: [...sel] }); toast.success(`${data.archived.length} DEMO hesap arşivlendi`); onDone(); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="max-w-xl" data-testid="demo-archive-dialog">
        <DialogHeader><DialogTitle>DEMO hesapları arşivle</DialogTitle></DialogHeader>
        <p className="text-[12px] text-slate-500">Arşivlenen hesap silinmez: hareket geçmişi korunur, seçicilerden ve Nakit Akış açılışından düşer. Ayarlardan "Aktif Et" ile geri alınabilir.</p>
        {items && items.length === 0 && <div className="text-sm text-emerald-700" data-testid="demo-archive-empty">Aktif DEMO hesap yok.</div>}
        {(items || []).map((a) => (
          <label key={a.id} className="flex items-center gap-2 border-t py-1.5 text-sm" data-testid={`demo-archive-row-${a.code}`}>
            <input type="checkbox" checked={sel.has(a.id)} onChange={() => toggle(a.id)} data-testid={`demo-archive-select-${a.code}`} /><AccDot color={a.color} />
            <span className="font-mono text-xs">{a.code}</span>{a.name}<span className="ml-auto font-mono">{formatMoney(a.balance, a.currency)}</span><span className="text-[11px] text-slate-400">{a.movements} hareket</span></label>))}
        <Input placeholder="Gerekçe (zorunlu, en az 3 karakter)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="demo-archive-reason" />
        <DialogFooter><Button variant="outline" onClick={onClose}>Vazgeç</Button>
          <Button disabled={busy || !sel.size || reason.trim().length < 3} onClick={save} className="bg-amber-600 hover:bg-amber-700" data-testid="demo-archive-confirm">{sel.size} Hesabı Arşivle</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
